import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { Dialog, DialogContent } from '@mui/material'
import { useSnackbar } from 'notistack'
import PropTypes from 'prop-types'

import { useAddQuoteItemsFromPDFMutation } from '@/app/services/quoteItems'
import { useGetQuoteQuery } from '@/app/services/quotes'
import { selectOrganisationId } from '@/app/slices/organisationSlice'
import { setSelectedQuoteStatus } from '@/app/slices/quoteItemsSlice'
import { QUOTE_STATUS_ARRAY } from '@/common/utils/Constants/Constants'
import Pdf2Quote from '@/features/quotes/components/Pdf2Quote/Pdf2Quote'

const classes = {
    dialogContent: {
        display: 'flex',
        flexDirection: 'row',
        p: 0,
    },
}

const AddPDFPartsDialog = ({ onClose, open }) => {
    const { t } = useTranslation()
    const { enqueueSnackbar } = useSnackbar()
    const dispatch = useDispatch()

    const { quoteId } = useParams()
    const organisationId = useSelector((state) => selectOrganisationId(state))

    const { data: selectedQuote } = useGetQuoteQuery({ organisationId, quoteId })
    const [addQuoteItemsFromPdf] = useAddQuoteItemsFromPDFMutation()

    const handleClose = () => {
        onClose()
    }

    const handleAddPDFParts = async () => {
        if (selectedQuote.status !== QUOTE_STATUS_ARRAY.NotCalculated) {
            dispatch(setSelectedQuoteStatus(QUOTE_STATUS_ARRAY.NotCalculated))
        }

        try {
            await addQuoteItemsFromPdf({ organisationId, quoteId: quoteId }).unwrap()
            enqueueSnackbar(`${t('PDF part added to $t(quote)')}`, { variant: 'success' })
            handleClose()
        } catch (error) {
            const errorMessage = t('$t(An error occurred) adding PDF part')
            enqueueSnackbar(errorMessage, { variant: 'error', autoHideDuration: 5000 })
            handleClose()
        }
    }

    return (
        <Dialog
            fullScreen={true}
            open={open}
            sx={classes.dialogRoot}
            onClose={handleClose}
        >
            <DialogContent sx={classes.dialogContent}>
                <Pdf2Quote
                    quoteId={quoteId}
                    onCancelClicked={handleClose}
                    onSubmitClicked={handleAddPDFParts}
                />
            </DialogContent>
        </Dialog>
    )
}

AddPDFPartsDialog.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
}

export default AddPDFPartsDialog
